import { render, staticRenderFns } from "./ErpTable.vue?vue&type=template&id=3175d94d&scoped=true"
import script from "./ErpTable.vue?vue&type=script&lang=js"
export * from "./ErpTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3175d94d",
  null
  
)

export default component.exports